"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _HR = _interopRequireDefault(require("UIComponents/elements/HR"));

var _UILegacySideNav = _interopRequireDefault(require("UIComponents/legacy/UILegacySideNav"));

var _UINestedNav = _interopRequireDefault(require("UIComponents/nav/UINestedNav"));

var _UIRouterNestedNavItem = _interopRequireDefault(require("ui-addon-react-router/UIRouterNestedNavItem"));

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router/UIRouterLink"));

var _withPartials = _interopRequireDefault(require("marketplace-lib/components/hocs/withPartials"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var CategoryNavigation = function CategoryNavigation(_ref) {
  var categoryFilter = _ref.categoryFilter,
      options = _ref.options,
      parent = _ref.parent,
      partial = _ref.partial,
      trackAdjustedFilter = _ref.trackAdjustedFilter,
      trackLinkClick = _ref.trackLinkClick;

  var handleTrackAdjustedFilter = function handleTrackAdjustedFilter(value) {
    trackAdjustedFilter(_GoodFiltersAndPage.default.SUB_TYPE, value);
  };

  return _react.default.createElement("div", null, _react.default.createElement(_UILegacySideNav.default, null, _react.default.createElement(_UIRouterLink.default, {
    onClick: trackLinkClick.bind(null, "view-installed-" + parent),
    to: "/manage-purchases?subType=" + parent
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "sidebar.purchasedLabel." + parent
  })), _react.default.createElement(_HR.default, {
    className: "m-y-1"
  })), _react.default.createElement(_UINestedNav.default, {
    value: categoryFilter
  }, _react.default.createElement(_UIRouterNestedNavItem.default, {
    onClick: partial(handleTrackAdjustedFilter, parent),
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "sidebar.allCategoryLabel." + parent
    }),
    to: "/products?subType=" + parent,
    value: parent
  }), options.map(function (option) {
    return _react.default.createElement(_UIRouterNestedNavItem.default, {
      key: option.value,
      className: "integrate-category-" + option.value,
      defaultOpen: categoryFilter === option.value,
      onClick: partial(handleTrackAdjustedFilter, option.value),
      value: option.value,
      title: option.text,
      to: "/products?subType=" + option.value
    }, option.options && option.options.map(function (childOption) {
      return _react.default.createElement(_UIRouterNestedNavItem.default, {
        key: childOption.value,
        className: "integrate-category-" + childOption.value,
        onClick: partial(handleTrackAdjustedFilter, childOption.value),
        value: childOption.value,
        title: childOption.text,
        to: "/products?subType=" + childOption.value
      });
    }));
  })));
};

CategoryNavigation.propTypes = {
  categoryFilter: _react.PropTypes.string.isRequired,
  options: _react.PropTypes.instanceOf(_immutable.OrderedSet).isRequired,
  parent: _react.PropTypes.string.isRequired,
  partial: _react.PropTypes.func.isRequired,
  trackAdjustedFilter: _react.PropTypes.func.isRequired,
  trackLinkClick: _react.PropTypes.func.isRequired
};

var _default = (0, _withPartials.default)(CategoryNavigation);

exports.default = _default;
module.exports = exports.default;